export default "__VITE_ASSET__c35b72d4__"